export default __webpack_public_path__ + "static/media/sidebar.cfbfa9d7.jpg";